import {accordion} from "./modules/accordion";
import {autocomplete} from "./modules/autocomplete";
import {lazyBg} from "./modules/lazy-bg";
import {lazyLoad} from "./modules/lazy-load";
import {navigation} from "./modules/navigation";
import {modal} from "./modules/modal";
import {smoothScroll} from "./modules/smooth-scroll";
import {validation} from "./modules/validation";
import {radioSwitcher} from "./modules/radio"; 
import {sliders} from "./modules/sliders"; 
import {toggler} from "./modules/toggler";
import {recaptchaDelay} from "./modules/recaptcha-delay";
import {passwordPageLogout} from "./modules/password-page-logout";
import {counter} from "./modules/counter";
import {bulkUpload} from "./modules/bulk-upload";

function onDocumentReady() {
    accordion.init();
    autocomplete.init();
    lazyBg.init();
    lazyLoad.init();
    navigation.init();
    modal.init();
    smoothScroll.init();
    validation.init();
    radioSwitcher.init(); 
    sliders.init();
    toggler.init();
    recaptchaDelay.init();
    passwordPageLogout.init();
    counter.init();
    bulkUpload.init();

    // setTimeout(() => onetrustUpdate.init(), 1000);
}

if (document.readyState !== "loading") {
    onDocumentReady(); // Or setTimeout(onReady, 0); if you want it consistently async
} else {
    document.addEventListener("DOMContentLoaded", onDocumentReady);
}
